module.exports = __webpack_public_path__ + "img/kenderdudet01.475d203e.jpeg";